import constants from '@playcastdotio/GlobalConfig';
import { Link } from 'react-router-dom';
import { PageBody, library } from '@playcastdotio/ArticleContent';
import { Button } from '@playcastdotio/Shadcn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { download } from '../../utility/api';
import { faWindows } from '@fortawesome/free-brands-svg-icons';
import { isMobileDevice } from '../../utility/base';
import { useEffect } from 'react';

export const Changelog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div className='w-full h-auto m-0 p-0 bg-content text-content-text'>
      <div className='w-full h-auto m-0 p-0 bg-hero bg-cover bg-no-repeat bg-content text-content-text'>
        <div className='container mx-auto w-full h-auto pt-20 pb-8 px-8'>
          <section id='hero' className='grid grid-cols-12 gap-y-8 gap-x-4'>
            <div className='col-span-full md:col-span-6 grid grid-rows content-center gap-y-4 lg:gap-y-8'>
              <h1 className='row-auto font-bold text-3xl lg:text-4xl'>Changelog</h1>
              <p>Playcast is now officially live! </p>
              <p className='-mt-4'>
                Please give us your feedback in Discord; hopefully you find each version better than the last. But don't hesitate to report
                our bugs!{' '}
              </p>
              <div className='row-auto flex flex-row gap-2'>
                {!isMobileDevice() && (
                  <Button className='rounded-full flex space-x-2' onClick={download}>
                    <FontAwesomeIcon icon={faWindows} className='text-2xl' />
                    <span>Download v{constants.VERSION}</span>
                  </Button>
                )}
              </div>
            </div>

            <div className='col-span-full md:col-span-5 md:col-start-8 content-center'>
              <img src='/images/preview-image.png' alt='screenshot' />
            </div>
          </section>
        </div>
      </div>
      <div className='w-full h-auto m-0 bg-content-secondary text-content-text'>
        <div className='container w-full h-auto mx-auto px-0 py-20 '>
          <section id='features' className='flex flex-col gap-10 md:gap-8 px-4 md:px-4 lg:px-20 xl:px-56'>
            <p className="text-xl">We have moved the Changelog into the <Link to='/news' className="underline text-yellow-500 underline-offset-2 font-bold">News</Link> section.</p>
            <h2 className='col-span-10 col-start-2 text-3xl'>Releases</h2>
            <PageBody article={library.pages.changelog} />
          </section>
        </div>
      </div>
    </div>
  );
};
